<template>
    <div class="bread-crumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
                v-for="(item, i) in list"
                :key="i"
                @click.native="onCrumbClick(item, i)">
                {{ item.name }}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
export default {
    name: 'BreadCrumb',
    inject: ['reload'],
    props: {
        list: {
            type: Array,
            default: () => ([])
        }
    },
    methods: {
        onCrumbClick (router, index) {
            if (index === this.list.length - 1) {
                return
            }
            this.$router.push({
                name: 'FolderList',
                params: {
                    levels: router.levels
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.bread-crumb {
    display: inline-block;
    line-height: 50px;
    /deep/ {
        .el-breadcrumb__inner {
            color: #333333;
            cursor: pointer;
        }
    }
}
</style>